import { Calendar, Star, Eye } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";

interface Assignment {
  id: string;
  course_day: number;
  theme: string;
  submitted_at: string;
  score: number | null;
  photos: string[];
  views: number;
}

interface AssignmentHistoryProps {
  assignments: Assignment[];
  onViewAssignment: (assignment: Assignment) => void;
}

export const AssignmentHistory = ({ assignments, onViewAssignment }: AssignmentHistoryProps) => {
  return (
    <Card className="shadow-[var(--shadow-medium)]">
      <CardHeader>
        <CardTitle>提交历史</CardTitle>
        <CardDescription>查看您已提交的所有作业</CardDescription>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[400px] pr-4">
          <div className="space-y-3">
            {assignments.length === 0 ? (
              <p className="text-center text-muted-foreground py-8">
                暂无提交记录
              </p>
            ) : (
              assignments.map((assignment) => (
                <div
                  key={assignment.id}
                  onClick={() => onViewAssignment(assignment)}
                  className="p-4 rounded-lg border bg-card hover:shadow-md transition-all cursor-pointer"
                >
                  <div className="flex items-start justify-between mb-2">
                    <div className="flex items-center gap-2">
                      <Badge variant="secondary">第 {assignment.course_day} 天</Badge>
                      <span className="font-medium">{assignment.theme}</span>
                    </div>
                    {assignment.score && (
                      <Badge className="flex items-center gap-1">
                        <Star className="h-3 w-3" />
                        {assignment.score}分
                      </Badge>
                    )}
                  </div>
                  
                  <div className="flex items-center gap-4 text-xs text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <Calendar className="h-3 w-3" />
                      {new Date(assignment.submitted_at).toLocaleDateString()}
                    </div>
                    <div className="flex items-center gap-1">
                      <Eye className="h-3 w-3" />
                      {assignment.views || 0} 次查看
                    </div>
                  </div>

                  <div className="flex gap-2 mt-3">
                    {assignment.photos.slice(0, 3).map((photo, idx) => (
                      <div key={idx} className="w-16 h-16 rounded overflow-hidden border">
                        <img src={photo} alt="" className="w-full h-full object-cover" />
                      </div>
                    ))}
                    {assignment.photos.length > 3 && (
                      <div className="w-16 h-16 rounded border bg-muted flex items-center justify-center text-xs">
                        +{assignment.photos.length - 3}
                      </div>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};
